import { parseEsimMatchingId } from "@/utils/esimActivationCode";

const APPLE_INSTALL_BASE =
  "https://esimsetup.apple.com/esim_qrcode_provisioning";
const ANDROID_INSTALL_BASE =
  "https://esimsetup.android.com/esim_qrcode_provisioning";

const isIpadUserAgent = (ua: string): boolean =>
  /iPad/.test(ua) ||
  (/Macintosh/.test(ua) &&
    typeof navigator !== "undefined" &&
    navigator.maxTouchPoints > 1);

/**
 * Phone-only OS install URL for a complete `LPA:1$…` string.
 * iPad, Android tablets, and desktop return `null` so the UI can show a QR.
 */
export const getEsimInstallUrl = (lpa: string): string | null => {
  const carddata = encodeURIComponent(lpa);
  const ua = navigator.userAgent;

  if (isIpadUserAgent(ua)) {
    return null;
  }

  if (/iPhone|iPod/.test(ua)) {
    return `${APPLE_INSTALL_BASE}?carddata=${carddata}`;
  }

  if (/Android/.test(ua) && /Mobile/.test(ua)) {
    return `${ANDROID_INSTALL_BASE}?carddata=${carddata}`;
  }

  return null;
};

/**
 * Navigates same-tab to the native eSIM installer when this device is a
 * supported phone. Returns false so callers can fall back to QR / Details.
 */
export const tryNavigateToEsimInstall = (
  matchingId: string | undefined,
): boolean => {
  const lpa = matchingId
    ? parseEsimMatchingId(matchingId)?.completeActivationCode
    : undefined;
  const url = lpa ? getEsimInstallUrl(lpa) : null;
  if (!url) {
    return false;
  }
  window.location.assign(url);

  return true;
};
